<picture>
    <source srcset="/assets/img/logo.webp" type="image/webp">
    <img src="/assets/img/logo.png"
         class="logo"
         alt="Logo"
         aria-hidden="true"
         width="300"
         height="44">
</picture>
